import { LocalTime } from '@js-joda/core';
import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for LocalTime
 */
export const localTimeSerializer = CreateSerializer(serializeLocalTime, deserializeLocalTime);
function serializeLocalTime(value) {
    return Object.assign(LocalTime.now(), value).toString();
}
function deserializeLocalTime(value) {
    return LocalTime.parse(value);
}
